// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconRmsReshoot_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s24IconSvg = html `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M5 0H11L12 2H4L5 0ZM10 9C10 10.1046 9.10457 11 8 11 6.89543 11 6 10.1046 6 9 6 7.89543 6.89543 7 8 7 9.10457 7 10 7.89543 10 9Z" class="svg-bg"/>
  <path d="M0 3H16V8C14.5627 8 13.2042 8.33733 11.9995 8.9362 11.9654 6.75648 10.1878 5 8 5 5.79086 5 4 6.79086 4 9 4 11.1485 5.69386 12.9013 7.819 12.996L6.42114 15H0V3ZM16 10C13.6213 10 11.5196 11.1865 10.2547 13H12.9995C13.8353 12.3721 14.8742 12 16 12 18.7614 12 21 14.2386 21 17H20L22 20 24 17H23C23 13.134 19.866 10 16 10ZM21.7453 21C20.4804 22.8135 18.3787 24 16 24 12.134 24 9 20.866 9 17H8L10 14 12 17H11C11 19.7614 13.2386 22 16 22 17.1258 22 18.1647 21.6279 19.0005 21H21.7453Z" class="svg-bg"/>
</svg>
`;
/**
 * IconRmsReshoot is a generated icon component.
 */
let IconRmsReshoot = IconRmsReshoot_1 = class IconRmsReshoot extends IconBaseElement {
    render() {
        return html `${IconRmsReshoot_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconRmsReshoot.icons = new Map([
    ['s8', _s24IconSvg],
    ['s12', _s24IconSvg],
    ['s16', _s24IconSvg],
    ['s24', _s24IconSvg],
    ['s32', _s24IconSvg],
    ['s40', _s24IconSvg],
    ['s48', _s24IconSvg],
    ['s64', _s24IconSvg],
    ['s72', _s24IconSvg],
    ['s80', _s24IconSvg],
]);
IconRmsReshoot = IconRmsReshoot_1 = __decorate([
    customElement('zui-icon-rms-reshoot')
], IconRmsReshoot);
export { IconRmsReshoot };
